export default __webpack_public_path__ + "static/media/francheville06.06748738.jpg";